export default __webpack_public_path__ + "static/media/exclamation.974b690b.svg";